document.addEventListener('DOMContentLoaded', () => {
  const expandedTextElems = document.querySelectorAll('.expanded-text')

  const expandText = (text, btn) => {
    text.classList.remove('collapsed')
    btn.classList.remove('show')
  }

  for(let i = 0; i < expandedTextElems.length; i++ ){
    let expandedText = expandedTextElems[i]
    if(expandedText.offsetHeight > 72){
      let expandBtn = expandedText.parentElement.querySelector('.expanded-btn')
      expandBtn.classList.add('show')
      expandBtn.addEventListener('click', (e) => expandText(expandedText, e.target))

      expandedText.classList.add('collapsed')
    }
  
  }
})